import isEmpty from "lodash/isEmpty";

const deserializeRegisteredEvents = async (registeredEvents = {}) => {
    if (isEmpty(registeredEvents.meetings)) return {};

    return registeredEvents.meetings.reduce((data, event) => {
        data[event.cms_event_id] = {
            ...event,
            registered: true,
        };
        return data;
    }, {});
};

export { deserializeRegisteredEvents };
